import { getDomainName, langFallback$Fetch } from '~/lang/utils/langfetch'

export async function submitEmailLogin(
  {
    email,
    password,
  }: {
    email: string
    password: string
  },
  { langCode }: { langCode: string },
) {
  try {
    const response: any = await langFallback$Fetch(
      langCode,
      `/email-jwt?domain=${getDomainName()}`,
      {
        method: 'POST',
        mode: 'cors',
        credentials: 'same-origin',
        body: JSON.stringify({ email, password }),
      },
    )

    return response.token
      ? { isManager: response.is_manager }
      : { message: response.error.__all__[0] }
  } catch (e: any) {
    // Handle the new email verification error format
    if (e.data && e.data.error === 'email_not_verified') {
      throw {
        message: e.data.message,
      }
    }

    const extractFormError = (response: any): string | null => {
      const errors = response?.data?.errors || response?._data?.errors
      return errors?.__all__?.[0] || null
    }

    const formError = extractFormError(e.response)
    if (formError) {
      throw {
        message: formError,
        formError: formError,
      }
    }

    // Only use generic fallback if no server message available
    throw { message: 'Login failed' }
  }
}
